import {OpenPositionReportModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface
} from '../../../app/shared/components/report-table';


export const PanelAccountsEditCurrentPositionsDataTableItems = (
    hiddenAccountColumn: boolean = false
): ReportTableData[] => {
    const tableDataItems = [
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getClientAccountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: OpenPositionReportModel.getSymbolSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getCurrencySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: OpenPositionReportModel.getQuantitySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getAverageOpeningPriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getLastMarketPriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getCostSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getMarketValueSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: OpenPositionReportModel.getUnrealisedPnlSelector(),
            value: null,
            hidden: false
        })
    ];

    if (hiddenAccountColumn) {
        return tableDataItems.filter((tableData: ReportTableData) => {
            return tableData.colId !== OpenPositionReportModel.getClientAccountSelector();
        });
    }

    return tableDataItems;
};

export const PanelAccountsEditCurrentPositionsDataTableConfig = (
    hiddenAccountColumn: boolean = false
): ReportTableConfigInterface => {
    const config: ReportTableConfigInterface = {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Account',
                selector: OpenPositionReportModel.getClientAccountSelector()
            }),
            new ReportTableColumn({
                label: 'Symbol',
                selector: OpenPositionReportModel.getSymbolSelector()
            }),
            new ReportTableColumn({
                label: 'Currency',
                selector: OpenPositionReportModel.getCurrencySelector()
            }),
            new ReportTableColumn({
                label: 'Qty',
                selector: OpenPositionReportModel.getQuantitySelector()
            }),
            new ReportTableColumn({
                label: 'Average Price',
                selector: OpenPositionReportModel.getAverageOpeningPriceSelector()
            }),
            new ReportTableColumn({
                label: 'Last Price',
                selector: OpenPositionReportModel.getLastMarketPriceSelector()
            }),
            new ReportTableColumn({
                label: 'Cost',
                selector: OpenPositionReportModel.getCostSelector()
            }),
            new ReportTableColumn({
                label: 'Market Value',
                selector: OpenPositionReportModel.getMarketValueSelector()
            }),
            new ReportTableColumn({
                label: 'Unrealized PnL',
                selector: OpenPositionReportModel.getUnrealisedPnlSelector()
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };

    if (hiddenAccountColumn) {
        config.columns = config.columns.filter((column: ReportTableColumn) => {
            return column.selector !== OpenPositionReportModel.getClientAccountSelector();
        });
    }

    return config;
};
